import React from "react";
import "./OrderDetailSkeleton.css";

export default function OrderDetailSkeleton() {
  return (
    <div className="p-4 order-detail-skeleton" dir="rtl">

      {/* =====================================
          Back Header
      ====================================== */}

      <div className="backOrder skeleton-backOrder">
        <span className="skeleton skeleton-icon"></span>
        <span className="skeleton skeleton-title"></span>
      </div>


      {/* =====================================
          Order Information
      ====================================== */}

      <div className="orderDetails">

        <h2>
          <span className="skeleton skeleton-heading-icon"></span>
          <span className="skeleton skeleton-heading"></span>
        </h2>

        <div className="orderAmount brl">

          <div className="trackingCode">
            <span className="skeleton skeleton-label"></span>
            <span className="skeleton skeleton-value"></span>
          </div>

          <div className="orderRegDate">
            <span className="skeleton skeleton-label"></span>
            <span className="skeleton skeleton-value"></span>
          </div>

          <div className="amountPaid">

            <div className="amountReg">

              <div className="amount brl">
                <span className="skeleton skeleton-label"></span>
                <span className="skeleton skeleton-price"></span>
              </div>

              <div className="shipping">
                <span className="skeleton skeleton-label"></span>
                <span className="skeleton skeleton-price"></span>
              </div>

            </div>

            <div className="amountTotal">

              <div className="amountTotalPaid">
                <span className="skeleton skeleton-total-label"></span>
                <span className="skeleton skeleton-total-price"></span>
              </div>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================
          Transaction History
      ====================================== */}

      <div className="transactionHistory">

        <h2>
          <span className="skeleton skeleton-heading-icon"></span>
          <span className="skeleton skeleton-heading"></span>
        </h2>

        <div className="transaction">

          <div className="transaction-table-skeleton">

            {/* Desktop table header */}

            <div className="transaction-row-skeleton transaction-header-skeleton">

              <span className="skeleton"></span>
              <span className="skeleton"></span>
              <span className="skeleton"></span>
              <span className="skeleton"></span>
              <span className="skeleton"></span>
              <span className="skeleton"></span>

            </div>


            {/* Table row */}

            <div className="transaction-row-skeleton">

              <span className="skeleton"></span>
              <span className="skeleton"></span>
              <span className="skeleton"></span>
              <span className="skeleton"></span>
              <span className="skeleton"></span>
              <span className="skeleton"></span>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================
          Delivery Information
      ====================================== */}

      <div className="orderDelivery">

        <h2>
          <span className="skeleton skeleton-heading-icon"></span>
          <span className="skeleton skeleton-heading"></span>
        </h2>

        <div className="orderDelivery-user">

          <div className="receiver">

            <div className="receiverOrder">

              <div className="mobile brl">
                <span className="skeleton skeleton-label"></span>
                <span className="skeleton skeleton-value"></span>
              </div>

              <div className="receiverUser">
                <span className="skeleton skeleton-label"></span>
                <span className="skeleton skeleton-value"></span>
              </div>

            </div>


            <div className="location">

              <div className="locationTo">

                <span className="skeleton skeleton-location-label"></span>

                <span className="skeleton skeleton-location"></span>

              </div>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================
          Products
      ====================================== */}

      <div className="orderProducts">

        {/* Shipment header */}

        <div className="orderFactorGet">

          <span className="skeleton skeleton-factor-title"></span>

          <span className="skeleton skeleton-invoice"></span>

        </div>


        {/* Shipping type */}

        <div className="orderSend">

          <div className="skeleton skeleton-send-icon"></div>

          <span className="skeleton skeleton-send-title"></span>

          <span className="skeleton skeleton-product-count"></span>

        </div>


        {/* Shipment information */}

        <div className="orderDelivery-user">

          <div className="receiver">

            <div className="receiverOrder">

              <div className="trackCode brl">

                <span className="skeleton skeleton-label"></span>

                <span className="skeleton skeleton-value"></span>

              </div>


              <div className="receiverUser">

                <span className="skeleton skeleton-label"></span>

                <span className="skeleton skeleton-status"></span>

              </div>

            </div>


            <div className="location">

              <div className="shippingCost">

                <span className="skeleton skeleton-label"></span>

                <span className="skeleton skeleton-price"></span>

              </div>

            </div>


            {/* =================================
                Products List
            ================================== */}

            <div className="orderProductsItem">

              <SkeletonProduct />
              <SkeletonProduct />
              <SkeletonProduct />

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}


/*
|--------------------------------------------------------------------------
| Product Skeleton
|--------------------------------------------------------------------------
*/

function SkeletonProduct() {
  return (
    <div className="ordersItemShow">

      <div className="order-image-box">

        <span className="skeleton skeleton-product-image"></span>

      </div>


      <div className="order-factor-info">

        <span className="skeleton skeleton-product-name"></span>

        <span className="skeleton skeleton-product-name short"></span>

        <span className="skeleton skeleton-product-line"></span>

        <span className="skeleton skeleton-product-line"></span>

      </div>

    </div>
  );
}